import {ConfigProvider} from '../../../application/config/configProvider';
import OfferViewManager from './offerViewManager';

export default class OfferViewFacade {
    /**
     *
     * @param {Element} listContentElement
     * @param {string} targetSelector
     * @param {string} valueAttribute
     */
    static notifyAboutAllAvailable(listContentElement, targetSelector = '[data-element="offer"]', valueAttribute = 'data-value') {
        let manager = new OfferViewManager(listContentElement, ConfigProvider.get('offer_seen_endpoint'), targetSelector),
            availableOfferElements = [...manager.detectAvailable()],
            offerIds = [];

        availableOfferElements.forEach(element => {
            offerIds.push(element.getAttribute(valueAttribute));
        });

        if (offerIds.length > 0) {
            manager.notify(offerIds);
        }
    }
}
